export default theme => ({
  signIn: {
    fontSize: 11,
    color: theme.grey2
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 10,
    '& > *': {
      marginLeft: 10
    }
  },
  signingKey: {
    width: '100%',
    boxShadow: '0px 3px 20px rgba(48, 206, 202, 0.2)',
    borderRadius: 10,
    marginBottom: 20,
    padding: '5px 20px',
    color: theme.white1,
    backgroundColor: theme.teal1,
    '& > dl > dd > div[data-is-idle="true"]': {
      color: theme.white1
    }
  },
  passwordPrompt: {
    padding: '7px 0'
  }
});
